const TypingIndicator = () => {	
	return (
		<div className="typing-indicator-bar">
			<div className="typing-indicator">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
	);
};

export default TypingIndicator;